// src/lib/eventTokens.js
import api from "@/lib/axios";

export async function createPlanToken({ location_id = 10, items = [], meta = {} }) {
  const { data } = await api.post("/event-menu-plan/plan-tokens", {
    location_id,
    items,
    meta,
  });
  return data; // { token, expires_at, ttl_minutes }
}

export function replenishmentUrl(token) {
  const u = new URL(window.location.origin);
  u.pathname = "/inventory/replenishment";
  u.searchParams.set("token", token);
  return u.toString();
}
